// index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Suspense } from "react";
import "./index.css";
import "./i18n";

// Global Buffer setup for compatibility
import { Buffer } from "buffer";
window.Buffer = Buffer;

// Unhandled promise rejection log
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled Promise Rejection:", {
    reason: event.reason,
    promise: event.promise,
    stack: event.reason?.stack,
  });
});

const container = document.getElementById("root");

if (!container) {
  throw new Error("React root element doesn't exist!");
}

ReactDOM.createRoot(container).render(
  // <React.StrictMode>
  <Suspense fallback={<div>Loading...</div>}>
    <App />
  </Suspense>
  //</React.StrictMode>
);
